<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready && selects.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span>Снять средства – {{ labels[type] }} ({{ entry.name ? entry.name : entry.full_name }})</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <select-field
                            v-if="type === 'accounts'"
                            class="w-1/2 px-2"
                            title="Фонд"
                            label="name"
                            valueName="id"
                            :options="selects.funds"
                            v-model="withdrawal.fund_id"
                            :errors="errors.fund_id"
                            :clearable="false"
                            required
                        />

                        <select-field
                            v-if="type !== 'accounts'"
                            class="w-1/2 px-2"
                            title="Счет"
                            label="name"
                            valueName="id"
                            :options="selects.accounts"
                            v-model="withdrawal.account_id"
                            :errors="errors.account_id"
                            :clearable="false"
                            required
                        />

                        <text-field
                            type="number"
                            min="0"
                            class="w-1/2 px-2"
                            title="Сумма"
                            v-model="withdrawal.amount"
                            :errors="errors.amount"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <button class="btn btn-primary">Отправить</button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: this.$route.meta.name,
                endpoint: this.$route.meta.endpoint
            },

            type: this.$route.meta.type,

            labels: {
                accounts: "Счет",
                funds: "Фонд",
                users: "Пользователь"
            },

            withdrawal: {},

            selects: {
                ready: false,
                accounts: [],
                funds: []
            }
        };
    },

    methods: {
        submit() {
            axios
                .post(
                    `/admin/billing/withdrawal/${this.type}/${this.entry.id}`,
                    this.withdrawal
                )
                .then(response => {
                    this.$message.success("Средства успешно сняты");

                    this.$router.push({
                        name: this.resource.name + ".edit",
                        params: {
                            id: this.entry.id
                        }
                    });
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
        },

        async fetchSelects() {
            if (this.type !== "accounts") {
                await axios.get("/admin/assets/accounts/all").then(response => {
                    this.selects.accounts = response.data.data.map(account => {
                        account.name =
                            account.name + " (" + account.balance + " ₽)";
                        return account;
                    });
                });
            } else {
                await axios.get("/admin/assets/funds/all").then(response => {
                    this.selects.funds = response.data.data.map(fund => {
                        fund.name = fund.name + " (" + fund.balance + " ₽)";
                        return fund;
                    });
                });
            }

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetchSelects();

        console.log(this.editing);
    },

    watch: {}
};
</script>